// Legacy and alternate location slugs that should resolve
// to an existing canonical location record.

export const locationAliases: Record<string, string> = {
  schaerbeek: 'schaarbeek',
  uccle: 'ukkel',
  merelbeke: 'merelbeke-melle',
  kruibeke: 'beveren-kruibeke-zwijndrecht',
  'de-pinte': 'nazareth-de-pinte',
  bonheiden: 'mechelen',
  putte: 'heist-op-den-berg',
  liedekerke: 'ninove',
  olen: 'geel',
  'oud-turnhout': 'turnhout',
  vosselaar: 'turnhout',
  balen: 'mol',
  dessel: 'mol',
  laakdal: 'geel',
  brasschaat: 'antwerpen',
  schoten: 'antwerpen',
  wijnegem: 'antwerpen',
};

// These pages already existed as dedicated SEO landing pages.
// We keep them as the preferred canonical versions.

export const dedicatedLocationPaths: Record<string, string> = {
  gent: '/roetfilter-reinigen-gent',
  'sint-niklaas': '/roetfilter-reinigen-sint-niklaas',
  dendermonde: '/roetfilter-reinigen-dendermonde',
  lokeren: '/roetfilter-reinigen-lokeren',
  aalst: '/roetfilter-reinigen-aalst',
  temse: '/roetfilter-reinigen-temse',
  deinze: '/roetfilter-reinigen-deinze',
  evergem: '/roetfilter-reinigen-evergem',
};

export function resolveLocationSlug(slug: string): string {
  return locationAliases[slug] || slug;
}

export function getCanonicalLocationPath(slug: string): string {
  const resolvedSlug = resolveLocationSlug(slug);

  return (
    dedicatedLocationPaths[resolvedSlug] ||
    `/locaties/${resolvedSlug}`
  );
}
